require('./polyfills')

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'es6-promise/auto'
import Vue from 'vue'
import Vuex from 'vuex'
import App from './App'
// import ScrollMagic from 'ScrollMagic'
// import debounce from 'lodash/debounce'

Vue.use(Vuex)

var __svg__ = {
  path: './assets/svg/**/*.svg',
  name: 'annualreview2017/static/svg/[hash].icons.svg'
}
require('webpack-svgstore-plugin/src/helpers/svgxhr')(__svg__)

Vue.config.productionTip = false

export const store = new Vuex.Store({
  state: {
    device: 0,
    menuOpen: false,
    downloadOpen: false,
    videoOpen: false,
    videoSrc: null,
    currentSection: null,
    windowWidth: document.documentElement.clientWidth,
    content: [],
    viewport: {
      width: 1920,
      height: 1080
    },
    sections: [
      'hero',
      'ceo-introduction',
      'focus-areas',
      'future-energy',
      'operations',
      'vision-values',
      'people',
      'governance',
      'financial-performance',
      'uk-power-network-services'
    ],
    colors: [
      'purple',
      'turq',
      'red',
      'smoke',
      'orange',
      'blue',
      'rust',
      'green',
      'lilac'
    ]
    // controller: new ScrollMagic.Controller()
    // headroom: null,
    // headroomConfig: {
    //   headroomOffset: 180,
    //   tolerance: 5
    // }
  },
  mutations: {
    setDevice (state, n) {
      state.device = n
    },
    setSection (state, section) {
      state.currentSection = section
    },
    // setSection: debounce((state, section) => {
    //   state.currentSection = section
    // }, 75),
    setWindow (state) {
      state.windowWidth = document.documentElement.clientWidth
    },
    toggleMenu (state) {
      state.menuOpen = !state.menuOpen
    },
    setMenu (state, val) {
      state.menuOpen = val
    },
    setDownload (state, val) {
      state.downloadOpen = val
    },
    setVideo (state, val) {
      state.videoSrc = (typeof val === 'string') ? val : null
      state.videoOpen = (typeof val === 'string')
    },
    setContent (state, data) {
      state.content = data
    }
  }
})

export const eventBus = new Vue()

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  render: h => h(App),
  components: { App }
})

// Vue.config.devtools = true



// WEBPACK FOOTER //
// ./src/main.js